module.exports = __webpack_public_path__ + "static/media/search-icon-120x120.3fb7508a.svg";